function processedCount(progress = {}) {
  const explicit = Number(progress.processed)
  if (Number.isFinite(explicit) && explicit >= 0) return explicit
  return Math.max(0, Number(progress.sent) || 0)
}

function segmentStatus(progress = {}, index) {
  if (!Array.isArray(progress.segments)) return ''
  const segment = progress.segments[index - 1]
  if (!segment) return ''
  return typeof segment === 'string' ? segment : segment.status || ''
}

module.exports = {
  processedCount,
  segmentStatus
}
